module.exports = __webpack_public_path__ + "img/ccards.9f33b565.png";